<template>
  <div class="content">
    <div class="configuracao_geral_header">
      <h3 class="configuracao_geral_header_title">
        Administração do Sistema
      </h3>
    </div>
    <div class="configuracao_geral_body">
      <b-tabs content-class=""
              class="configuracao_geral_body-border"
              align="left"
              active-nav-item-class="configuracao_geral_body--tab-active">
        <b-tab title="Atualizar registros da CRC">
          <AtualizarRegistros />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import AtualizarRegistros from '@/views/SofiaRei/AtualizarRegistros'

  export default {
    name: 'AdministracaoSistema',
    components: {
      AtualizarRegistros
    }
  }
</script>
<style lang="scss">
    @import '../scss/_utilities/exports';

    @media print {
      .configuracao_geral_header,
      .nav-tabs {
        display: none !important;
      }
    }

  .configuracao_geral {
    &_header {
      background: #074f7f;

      &_title {
        color: #FFFFFF;
        font-size: 24px;
        font-weight: 500;
        padding: 12px;
      }
    }

    &_body{
      & .nav-link {
        border: 1px solid $sinoreg-blue;
        color: $color-black;
        font-size: pxToRem(15);
        border-top-left-radius:5px;
        border-top-right-radius:5px;
      }

      & .nav-link:hover {
        border: 1px solid #696969;
        color: $color-black;
      }

      &--tab-active {
        background-color: $sinoreg-blue !important;
        border: 1px solid $sinoreg-blue !important;
        color: white !important;
        fill: white !important;
      }

      &-border ul.nav {
        border-bottom: 3px solid $sinoreg-blue !important;
      }

      &-border ul.nav > li > a,
      &-border ul.nav > li > a:hover {
        border-bottom: 0 solid $sinoreg-blue;
      }
    }
  }

  .hr_config {
    background: #067fbf;
  }

  .footer_config {
    margin: 45px 0 0 0;
  }
</style>
